/**
 * @description 鉴权类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import CookieHelper from '../utils/cookieHelper'

const cookieHelper = CookieHelper.getInstance()

class Authorize {
  /**
   * 构造函数，传入类和ajax方法
   * @param {*} thisClass
   * @param {*} ajaxFun
   */
  constructor (thisClass, ajaxFun) {
    this.ajaxAuthor = this._decorator(thisClass, ajaxFun)
  }
  // 装饰方法
  _decorator (that, fn) {
    const _self = that
    return function () {
      // console.info('decorator', arguments, _self)
      let args = arguments
      this._authorize(args)
      return fn.apply(_self, arguments)
    }
  }
  // 鉴权
  _authorize (args) {
    for (let i = 0; i < args.length; i++) {
      const item = args[i]
      if (item && item.auth) {
        delete item.auth
        if (!item.data) item.data = {}
        item.data.mvnoId = cookieHelper.getCookie('mvnoId');
        item.data.orgId = cookieHelper.getCookie('orgId');
        item.data.loginCustomerId = cookieHelper.getCookie('loginCustomerId');
        item.data.langType = sessionStorage.getItem('langType');
        item.data.partnerCode = "UKAPP";
        item.data.streamNo = `UKAPPH5${+new Date()}${parseInt(Math.random()*10000)}`;
        break
      }
    }
  }
  // session检查
  sessionCheck (res) {
    if (res.resultCode === '00000006' || res.resultCode === '00000007' 
      || res.resultCode === '00000008'
      ) {
      return true
    }
    return false
  }
  // 处理session过期
  handleSesstionTimeout () {

    //setTimeout(() => window.location.replace('/login'), 1000)
  }
}

export default Authorize


// WEBPACK FOOTER //
// ./src/logic/authorize.js